import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FolderKanban, Sparkles, Inbox, Settings, LogOut, ExternalLink, BookOpen, Feather, Images, Instagram } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/progetti", label: "Progetti", icon: FolderKanban },
  { to: "/admin/immagini", label: "Immagini", icon: Images },
  { to: "/admin/operazioni", label: "Operazioni", icon: Sparkles },
  { to: "/admin/richieste", label: "Richieste", icon: Inbox },
  { to: "/admin/libro", label: "Libro", icon: BookOpen },
  { to: "/admin/diario", label: "Diario di bordo", icon: Feather },
  { to: "/admin/instagram", label: "Instagram", icon: Instagram },
  { to: "/admin/impostazioni", label: "Impostazioni", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-cream flex font-sans font-normal">
      <aside className="w-60 shrink-0 bg-white border-r border-gray-200 flex flex-col fixed inset-y-0 hidden md:flex">
        <div className="px-6 py-5 border-b border-gray-200 flex items-center gap-3">
          <img src="/logo-mark.png" alt="Home Haven" className="h-9 w-auto" />
          <div><div className="font-serif text-lg tracking-[0.12em] font-semibold text-ink leading-none">HOME HAVEN</div><div className="text-[9px] uppercase tracking-[0.25em] text-stone mt-1">CMS</div></div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm rounded-md transition-colors ${isActive ? "bg-ink text-white" : "text-ink/70 hover:bg-gray-100"}`}>
              <l.icon size={17} strokeWidth={1.6} />{l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-gray-200 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 text-sm text-ink/70 hover:bg-gray-100 rounded-md"><ExternalLink size={17} strokeWidth={1.6} />Vedi sito</Link>
          <button onClick={logout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-ink/70 hover:bg-gray-100 rounded-md"><LogOut size={17} strokeWidth={1.6} />Esci</button>
        </div>
      </aside>
      <div className="flex-1 md:ml-60 min-w-0">
        <header className="h-14 bg-white/80 backdrop-blur border-b border-gray-200 sticky top-0 z-30 flex items-center justify-between px-6">
          <nav className="md:hidden flex gap-3 text-xs overflow-x-auto">
            {LINKS.map((l) => <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => (isActive ? "text-ink font-medium" : "text-stone")}>{l.label}</NavLink>)}
          </nav>
          <div className="ml-auto flex items-center gap-4 text-xs text-stone">
            <span data-testid="admin-user-email">{user?.email}</span>
            <button onClick={logout} className="md:hidden text-ink"><LogOut size={16} /></button>
          </div>
        </header>
        <main className="p-6 md:p-10"><Outlet /></main>
      </div>
    </div>
  );
}
